module.exports = __webpack_public_path__ + "static/media/welders.82c88907.jpg";